import Swiper from "swiper/bundle";
import "swiper/css/bundle";

function initHeroGallerySlider() {
  const sliders = document.querySelectorAll(".hero-gallery-slider");

  sliders.forEach(function (slider) {
    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 3000,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    });
  });
}

export { initHeroGallerySlider };
